<template>
  <div id="company-auth">
    <mainHeader class="mainHeader" @logout="logoutClick"></mainHeader>
    <div class="wrapper">
      <div class="section section1">
        <span class="title" v-show="!isAuth">企业实名认证</span>
        <span class="title" v-show="isAuth">经办人实名认证</span>
        <span class="right" v-show="currentIndex===1" @click="goBackClick">返回上一步 ></span>
      </div>
      <div class="section section2" v-show="!isAuth">
        <div class="progress-box" v-for="(value,index) in steps" :key="index">
          <div class="line1" v-show="index>0"></div>
          <div class="circle" v-show="currentIndex<index+1">{{index+1}}</div>
          <div class="circle2" v-show="currentIndex===index+1">{{index+1}}</div>
          <div class="circle3" v-show="currentIndex>index+1"></div>
          <div class="line2" v-show="index<3"></div>
          <div class="title">{{value.title}}</div>
          <div class="title2" v-show="currentIndex>=index+1">{{value.title}}</div>
        </div>
      </div>
      <div class="section section3">
        <div class="content content1" v-show="currentIndex===1">
          <div class="title">经办人信息</div>
          <div class="input-box">
            <span>经办人姓名</span>
            <input placeholder="请输入经办人姓名" maxlength="15" v-model="name" :readonly="binPerson" v-on:focus="focus()"
              @blur="blur(0)" />
          </div>
          <div class="input-box">
            <span>经办人身份证号码</span>
            <input placeholder="请输入经办人身份证号" maxlength="18" v-model="identity_code" :readonly="binPerson"
              v-on:focus="focus()" @blur="blur(0)" />
          </div>
          <div class="input-box">
            <span>经办人手机号</span>
            <input placeholder="请输入经办人11位手机号" maxlength="11" v-model="phone" :readonly="binPerson"
              oninput="value=value.replace(/[^\d]/g,'')" v-on:focus="focus()" @blur="blur(1)" />
          </div>
          <div class="input-box">
            <span>手机号验证码</span>
            <input placeholder="请输入验证码" maxlength="6" v-model="code" v-on:focus="focus()" @blur="blur(0)" />
            <div class="codebtn" id="authCodeText" @click="codeClick">获取验证码</div>
          </div>
        </div>
        <div class="content content2" v-show="currentIndex===2">
          <div class="title">企业信息</div>
          <div class="input-box">
            <span>企业名称</span>
            <input placeholder="请输入企业名称" maxlength="30" :readonly="binCompanyInfo" v-model="company_name"
              v-on:focus="focus()" @blur="blur(0)" />
          </div>
          <div class="input-box textarea-box">
            <span class="span"> 统一社会信用代码或工商注册号</span>
            <textarea placeholder="请输入企业统一社会信用代码/工商注册号" :readonly="binCompanyInfo" maxlength="20" v-model="company_code"
              v-on:focus="focus()" @blur="blur(0)"></textarea>
          </div>
          <div class="input-box">
            <span>法人姓名</span>
            <input placeholder="请输入法人姓名" maxlength="15" v-model="legal_name" v-on:focus="focus()" @blur="blur(0)" />
          </div>
          <div class="input-box">
            <span>法人身份证号码</span>
            <input placeholder="请输入法人身份证号" maxlength="18" v-model="legal_code" v-on:focus="focus()" @blur="blur(0)" />
          </div>
        </div>
        <div class="content content3" v-show="currentIndex===3">
          <div class="auth-tip"><img src="../assets/tips.png">&nbsp;&nbsp;
            <span>认证信息：{{company_name + '（&nbsp;' + company_code + '&nbsp;）'}}</span>
          </div>
          <div class="title">授权信息</div>
          <div class="input-box">
            <span>法人手机号</span>
            <input placeholder="请输入法人11位手机号" maxlength="11" v-model="legal_phone"
              oninput="value=value.replace(/[^\d]/g,'')" v-on:focus="focus()" @blur="blur(1)" />
          </div>
          <!--          <div class="input-box image-box">-->
          <!--            <span>授权书</span>-->
          <!--            <input type="file" @change="imageClick($event)" accept="*.jpg,*.png,*.jpeg" />-->
          <!--            <img id="authImage" :src="emptyImg" />-->
          <!--            <div class="pre-btn" @click="preClick" >预览授权委托书</div>-->
          <!--          </div>-->
        </div>
        <div class="content content4" v-show="currentIndex===4">
          <div class="circle-image"></div>
          <div class="tip">法人代表授权正在签署中...</div>
          <div class="auth-btn" @click="bottomClick">再次发送授权</div>
        </div>
      </div>
      <div class="section4" id="bottomButton2" v-show="currentIndex===1">
        <img id='ruleImg' @click='ruleReadClick' src="../assets/radio_n.png" />
        <div class="tip1">我已阅读并同意<br /></div>
        <div class="tip2" @click='ruleClick'>《数字证书服务协议》</div>
        <div class="submit" @click='bottomClick' :style="{backgroundColor:activeStyle}">下一步</div>
      </div>
    </div>
    <bottomButton v-show="currentIndex===2||currentIndex===3" id="bottomButton" :title="currentIndex===2?'确定提交':'确定发送'"
      :state="bottomState" @click="bottomClick"></bottomButton>
  </div>
</template>

<script>
// import wxShare from '../wx/weixin.js'
import { Toast } from 'mint-ui'
import mainHeader from '../view/header'
import bottomButton from '../components/bottom-button'

export default {
  inject: ['reload'], // 界面刷新
  data () {
    return {
      addressVisible: false,
      bottomState: 0,
      emptyImg: require('../assets/icon-contract.png'),
      steps: [
        { title: '经办人信息' },
        { title: '企业信息' },
        { title: '发送授权' },
        { title: '法人授权' }
      ],
      planId: 0,
      timer: '', // 手机号 验证码倒计时
      timerCount: 60,
      codeabled: true,
      haveCode: 0, // 是否点击了获取验证码
      timerState: '', // 已发起授权 轮询
      name: '',
      phone: '',
      identity_code: '',
      code: '',
      company_name: '',
      company_code: '',
      legal_name: '',
      legal_code: '',
      legal_phone: '',
      currentIndex: 1,
      binCompanyInfo: false,
      binPerson: false, // 禁止输入经办人信息
      activeStyle: '#FECDCD',
      isRead: 0,
      orderState: 0, // 是否 下单 1 已下单
      orderDate: {}, // 订单状态
      isAuth: false
    }
  },
  methods: {
    logoutClick: function () { // 退出登录
      this.$router.push({ path: 'home' })
    },
    goBackClick: function () {
      var _this = this
      let param = {
        solutions_id: this.planId
      }
      this.utils.POST(this.accountUrl + '/ESign/back', param, function (response) {
        if (parseInt(response.code) === 0) {
          _this.$router.go(-1)
        }
      })
    },
    blur: function (index) {
      if (this.utils.isIphone()) { // iphone 适配键盘 弹出 回弹
        const currentScrollY = window.scrollY
        window.scrollTo(0, currentScrollY)
      } else {
        if (this.currentIndex === 1) {
          document.getElementById('bottomButton2').style.display = 'block'
        }
        if (this.currentIndex === 2 || this.currentIndex === 3) {
          document.getElementById('bottomButton').style.display = 'block'
        }
      }
      if (index === 1) {
        if (!this.utils.isPhone(this.phone)) {
          Toast('请输入正确的手机号')
        }
      }
    },
    focus: function () {
      console.log('==========')
      if (!this.utils.isIphone()) {
        if (this.currentIndex === 1) {
          document.getElementById('bottomButton2').style.display = 'none'
        }
        if (this.currentIndex === 2 || this.currentIndex === 3) {
          document.getElementById('bottomButton').style.display = 'none'
        }
      }
    },
    ruleReadClick: function () {
      if (this.isRead === 0) {
        document.getElementById('ruleImg').src = require('../assets/radio_s.png')
        this.isRead = 1
      } else {
        document.getElementById('ruleImg').src = require('../assets/radio_n.png')
        this.isRead = 0
      }
    },
    ruleClick: function () {
      window.location.href = 'http://cdn.zxzx119.com/%E6%95%B0%E5%AD%97%E8%AF%81%E4%B9%A6%E6%9C%8D%E5%8A%A1%E5%8D%8F%E8%AE%AE%202018.12.25.pdf'
      // window.location.href = 'https://www.hao123.com/'
    },
    codeClick: function () {
      if (this.checkParam() === false) {
        return
      }
      if (this.timerCount !== 60) {
        return
      }

      if (this.codeabled === true) {
        var _this = this
        let param = {
          name: this.name,
          phone: this.phone,
          identity_code: this.identity_code,
          solutions_id: this.planId
        }
        this.utils.POST(this.accountUrl + '/ESign/verPerson', param, function (response) {
          console.log('========短信发送成功')
          if (parseInt(response.code) === 0) {
            _this.countDown()
            _this.haveCode = 1
            Toast('获取验证码成功')
          } else {
            if (response.data.msg !== undefined) {
              Toast(response.data.msg)
            }
            if (response.data.message !== undefined) {
              Toast(response.data.message)
            }
          }
        })
      }
    },
    countDown: function () { // 倒计时
      console.log('倒计时==========')
      this.codeabled = false
      var _this = this
      this.timer = setInterval(function () {
        if (_this.timerCount > 0) {
          --_this.timerCount
          document.getElementById('authCodeText').innerText = '已发送（' + _this.timerCount + 's）'
          console.log('倒计时==========' + _this.timerCount)
        } else {
          clearInterval(_this.timer)
          document.getElementById('authCodeText').innerText = '重新获取'
          _this.timerCount = 60
          _this.codeabled = true
        }
      }, 1000)
    },
    imageClick: function (e) {

    },
    preClick: function () {

    },
    checkParam: function () {
      if (this.currentIndex === 1) {
        if (this.utils.isNull(this.name)) {
          Toast('请输入经办人姓名')
          return false
        }
        if (this.utils.isNumber(this.name)) {
          Toast('请正确输入经办人姓名')
          return false
        }
        if (this.utils.isNull(this.identity_code)) {
          Toast('请输入经办人身份证号')
          return false
        }
        if (this.utils.isNull(this.phone)) {
          Toast('请输入经办人手机号')
          return false
        }
        if (!this.utils.isPhone(this.phone)) {
          Toast('请正确输入经办人手机号')
          return false
        }
      }
      if (this.currentIndex === 2) {
        if (this.utils.isNull(this.company_name)) {
          Toast('请输入企业名称')
          return false
        }
        if (this.utils.isNull(this.company_code)) {
          Toast('请输入企业注册号')
          return false
        }
        if (this.utils.isNull(this.legal_name)) {
          Toast('请输入法人姓名')
          return false
        }
        if (this.utils.isNull(this.legal_code)) {
          Toast('请正确输入法人身份证号')
          return false
        }
      }
      if (this.currentIndex === 3) {
        if (!this.utils.isNull(this.legal_phone)) {
          Toast('请输入法人手机号')
          return false
        }
      }
      return true
    },
    bottomClick: function () {
      if (this.checkParam() === false) {
        return
      }
      var _this = this
      if (this.currentIndex === 1) {
        if (this.haveCode <= 0) {
          Toast('请先获取验证码')
          return false
        }
        if (this.utils.isNull(this.code)) {
          Toast('请输入验证码')
          return false
        }
        if (this.isRead <= 0) {
          Toast('请阅读服务协议')
          return false
        }
        let param = {
          code: this.code,
          solutions_id: this.planId
        }
        this.utils.POST(this.accountUrl + '/ESign/verCode', param, function (response) {
          console.log('========短信发送成功')
          if (parseInt(response.code) === 0) {
            if (parseInt(response.data.code) === 0) {
              if (_this.isAuth === false) { // 已企业授权 直接签署合同
                _this.currentIndex = 2
                _this.loadCompanyInfo()
              } else {
                if (parseInt(localStorage.getItem('isApp')) === 1 && _this.utils.isIphone()) { // ios app 内嵌网页 签署合同
                  window.webkit.messageHandlers.contractSign.postMessage({ 'planId': _this.planId })
                } else {
                  _this.$router.push({ path: 'auth-online', query: { planId: _this.planId } })
                }
                // 签署合同 新窗口打开
                // let routeData = _this.$router.resolve({path: 'auth-online', query: {planId: _this.planId}})
                // window.open(routeData.href, '_blank')
              }
            } else {
              Toast('验证码校验不通过，请重新获取验证码')
            }
          }
        })
      }
      if (this.currentIndex === 2) {
        let param = {
          company_name: this.company_name,
          company_code: this.company_code,
          legal_name: this.legal_name,
          legal_code: this.legal_code,
          solutions_id: this.planId
        }
        this.utils.POST(this.accountUrl + '/ESign/createAccount', param, function (response) {
          if (parseInt(response.code) === 0) {
            if (parseInt(response.data.code) === 0) {
              _this.currentIndex = 3
              _this.loadCompanyInfo2()
            } else {
              if (response.data.msg !== undefined) {
                Toast(response.data.msg)
              }
              if (response.data.message !== undefined) {
                Toast(response.data.message)
              }
            }
          }
        })
      }
      if (this.currentIndex === 3) {
        let param = {
          legal_phone: this.legal_phone,
          solutions_id: this.planId
        }
        this.utils.POST(this.accountUrl + '/ESign/legalSign', param, function (response) {
          if (parseInt(response.code) === 0) {
            if (parseInt(response.data.code) === 0) {
              _this.currentIndex = 4
            } else {
              Toast(response.data.msg)
            }
          }
        })
      }
      if (this.currentIndex === 4) {
        let param = {
          solutions_id: this.planId
        }
        this.utils.POST(this.accountUrl + '/ESign/getLegalStatus', param, function (response) {
          if (parseInt(response.code) === 0) {
            // 重新进行法人手机号认证
            if (response.data.status === 'SIGNFAILED') {
              _this.currentIndex = 3
              _this.loadState()
            } else { // 重新发送授权
              Toast(response.data.message)
              _this.utils.POST(this.accountUrl + '/ESign/legalSignAgain', null, function (response2) {
                if (parseInt(response2.code) === 0) {
                  Toast('再次发送成功')
                }
              })
            }
          }
        })
      }
    },
    loadCompanyInfo: function () {
      var _this = this
      if (this.currentIndex === 2) {
        this.utils.GET(this.companyUrl + '/sign/getSignList?type=1', function (response) {
          if (parseInt(response.code) === 0) {
            let data = response.data[0]
            if (data.sign_type === '企业认证') {
              _this.company_name = data.ent_name
              _this.company_code = data.sign_code
              if (data.sign_status === '审核通过') {
                _this.binCompanyInfo = true
              }
            }
          }
        })
      }
    },
    loadCompanyInfo2: function () {
      var _this = this
      if (this.currentIndex === 3) {
        this.utils.GET(this.companyUrl + '/ent/json', function (response) {
          if (parseInt(response.code) === 0) {
            let data = response.data
            _this.company_name = data.ent_name
            _this.company_code = data.ent_id
          }
        })
      }
    },
    loadData: function () {
      // 获取 待实名 用户信息
      console.log('获取实名认证信息======================================1111111')
      this.binPerson = false
      var _this = this
      this.utils.GET(this.accountUrl + '/ESign/findPerson?solutions_id=' + this.planId, function (response) {
        let data = response.data
        if (parseInt(response.code) === 0) {
          _this.name = data.name
          _this.identity_code = data.identity_code
          _this.phone = data.phone
          _this.binPerson = true
        }
      })
    },
    loadState: function () {
      // 发起授权 进行轮训
      if (!this.utils.isNull(this.timerState)) {
        clearTimeout(this.timerState)
      }

      var _this = this
      // 获取单子状态  是否下单
      this.utils.GET(this.accountUrl + '/zxOrder/consultingOrderStatus?sId=' + this.planId, function (response) {
        _this.orderDate = response.data
        _this.orderState = parseInt(_this.orderDate.orderState)
        // -1说明此id的方案咨询记录不存在 0未生成订单 1订单已生成
        if (_this.orderState === 1) {
          // contract_online_status  合同展示字段[待实名 待认证 待授权 待签署 签署完成]
          if (_this.orderDate.check_status === '未选择') {

          }
          if ((_this.orderDate.contract_online_status === '待实名' && _this.orderDate.check_status === '已选择')) {
            // person_status 未发起 // 经办人实名认证字段
            console.log('状态==========================1')
            _this.currentIndex = 1
            // 抓取 经办人手机号
            // if (_this.binPerson === false) {
            //   let userInfo = JSON.parse(localStorage.getItem('userinfo'))
            //   console.log(userInfo)
            //   _this.phone = userInfo.tails.userinfo[0].phone
            // }
          }
          if (_this.orderDate.contract_online_status === '待认证') {
            // company_status 公司认证状态参考字段
            console.log('状态==========================2')
            _this.currentIndex = 2
            _this.loadCompanyInfo()
          }
          if (_this.orderDate.contract_online_status === '待授权') {
            if (_this.orderDate.legal_status === '未发起') { // 授权参考字段
              console.log('状态==========================3')
              _this.currentIndex = 3
              _this.loadCompanyInfo2()
            }
            if (_this.orderDate.legal_status === '已发起') { // 授权参考字段
              console.log('状态==========================4')
              _this.currentIndex = 4
              _this.timerState = setTimeout(function () {
                _this.loadState()
              }, 5000)
              // clearTimeout(_this.timerState)
            }
          }
          // 判断企业授权
          if (_this.orderDate.legal_status_global === '已授权') {
            _this.isAuth = true
          }
          if (_this.orderDate.contract_online_status === '待签署') {
            // contract_status  合同签署参考字段  // 跳转 签署合同
            console.log('状态==========================5 待签署')
            if (parseInt(localStorage.getItem('isApp')) === 1 && _this.utils.isIphone()) { // ios app 内嵌网页 签署合同
              window.webkit.messageHandlers.contractSign.postMessage({ 'planId': _this.planId })
            } else {
              _this.$router.push({ path: 'auth-online', query: { planId: _this.planId } })
            }
            // 签署合同 新窗口打开
            // let routeData = _this.$router.resolve({path: 'auth-online', query: {planId: _this.planId}})
            // window.open(routeData.href, '_blank')
          }
          if (_this.orderDate.contract_online_status === '签署完成') {
            // 跳转 已签署详情页
            console.log('状态==========================6 签署完成')
            _this.$router.push({ path: 'emergency-detail', query: { planId: _this.planId } })
          }
        }
        _this.loadData()
      })
    }
  },
  components: {
    mainHeader,
    bottomButton
  },
  watch: {
    isActive: function (val) {
      if (this.currentIndex === 1) {
        if (val === true) {
          this.activeStyle = '#C41335'
        } else {
          this.activeStyle = '#FECDCD'
        }
      } else {
        if (val === true) {
          this.bottomState = 1
        } else {
          this.bottomState = 0
        }
      }
    }
  },
  computed: { // 计算
    isActive: function () {
      if (this.currentIndex === 1) {
        if (this.name.length > 0 && this.phone.length > 0 &&
          this.identity_code.length > 0 && this.code.length > 0 && this.isRead === 1) {
          return true
        }
        return false
      }
      if (this.currentIndex === 2) {
        if (!this.utils.isNull(this.company_name) && !this.utils.isNull(this.company_code) &&
          !this.utils.isNull(this.legal_name) && !this.utils.isNull(this.legal_code)) {
          return true
        }
        return false
      }
      if (this.currentIndex === 3) {
        if (!this.utils.isNull(this.legal_phone)) {
          return true
        }
        return false
      }
      return false
    }
  },
  mounted () {
    // 微信 分享
    // wxShare.wxRegister('在线提问，为你解忧', '写出您的消防问题，数百位行业专家在线答疑', 'http://cdn.zxzx119.com/4689248674381824')
    // 登录状态
    this.planId = this.$route.query.planId
    var _this = this
    this.utils.isUserLogin(function (login) {
      console.log('==========' + login)
      if (login === 0) {
        Toast('您还未登录，请登录后再认证！')
        _this.$router.push({ path: 'login', query: { back: 1 } })
      } else {
        _this.loadState()
      }
    })
  }
}

</script>

<style scoped>
.mainHeader {
  position: fixed;
  top: 0px;
  height: 55px;
  width: 100%;
  z-index: 500;
}
.wrapper {
  position: absolute;
  height: 100%;
  width: 100%;
  margin-top: 55px;
  background-color: #f1f1f1;
}
.section {
  position: relative;
  width: 100%;
  background-color: #ffffff;
}
.section1 {
  height: 60px;
  box-sizing: border-box;
  border-bottom: #f1f1f1 solid 10px;
}
.section1 .title {
  height: 50px;
  line-height: 50px;
  color: #000;
  font-size: 16px;
  font-weight: bold;
  margin-left: 15px;
}
.section1 .right {
  position: absolute;
  right: 15px;
  height: 50px;
  line-height: 50px;
  color: #999999;
  font-size: 13px;
  font-weight: bold;
}
.section2 {
  height: 70px;
  background-color: #ffecec;
}
.section2 .progress-box {
  position: relative;
  top: 11px;
  width: 25%;
  float: left;
  height: 50px;
  /*border: solid 1px red;*/
  /*box-sizing: border-box;*/
}
.section2 .progress-box .line1 {
  position: absolute;
  top: 13px;
  left: 0px;
  width: calc(50% - 18px);
  height: 1px;
  background-color: #fe9797;
}
.section2 .progress-box .circle {
  position: absolute;
  top: 0px;
  left: calc(50% - 13px);
  width: 26px;
  height: 26px;
  line-height: 26px;
  background-color: #fecdcd;
  border-radius: 13px;
  text-align: center;
  color: #ffffff;
  font-size: 15px;
}
.section2 .progress-box .circle2 {
  position: absolute;
  top: 0px;
  left: calc(50% - 13px);
  width: 26px;
  height: 26px;
  line-height: 26px;
  background-color: #c41335;
  border-radius: 13px;
  text-align: center;
  color: #ffffff;
  font-size: 15px;
}
.section2 .progress-box .circle3 {
  position: absolute;
  top: 0px;
  left: calc(50% - 13px);
  width: 26px;
  height: 26px;
  background-image: url("../assets/icon-auth-s.png");
  background-size: cover;
  background-position: center center;
}
.section2 .progress-box .line2 {
  position: absolute;
  top: 13px;
  left: calc(50% + 18px);
  width: calc(50% - 18px);
  height: 1px;
  background-color: #fe9797;
}
.section2 .progress-box .title {
  position: absolute;
  top: 35px;
  left: 0px;
  right: 0px;
  height: 15px;
  line-height: 15px;
  text-align: center;
  color: #fe9797;
  font-size: 11px;
  text-align: center;
}
.section2 .progress-box .title2 {
  position: absolute;
  top: 35px;
  left: 0px;
  right: 0px;
  height: 15px;
  line-height: 15px;
  text-align: center;
  color: #c50b10;
  font-size: 11px;
  text-align: center;
}
.section3 {
  /*height: 270px;*/
  min-height: 260px;
  background-color: #ffffff;
}
.section3 .content .auth-tip {
  position: relative;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 35px;
  font-size: 11px;
  color: #c41335;
  background-color: #fff2d0;
}
.section3 .content .auth-tip img {
  position: absolute;
  left: 15px;
  top: 10px;
  width: 15px;
  height: 15px;
}
.section3 .content .auth-tip span {
  position: absolute;
  display: block;
  left: 37px;
  top: 1px;
  right: 12px;
  height: 35px;
  line-height: 35px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.section3 .content .title {
  position: relative;
  top: 6px;
  margin-left: 15px;
  height: 40px;
  line-height: 40px;
  font-size: 15px;
  font-weight: bold;
  color: #333333;
}
.section3 .input-box {
  position: relative;
  width: 100%;
  height: 55px;
  line-height: 55px;
  box-sizing: border-box;
  border-bottom: #eeeeee solid 1px;
}
.section3 .textarea-box {
  height: 80px;
}
.section3 .image-box {
  height: 180px;
}
.section3 .input-box span {
  padding-left: 15px;
  width: 100px;
  font-size: 14px;
  color: #333333;
}
.section3 .input-box .span {
  display: inline-block;
  margin-top: 16px;
  padding-left: 15px;
  width: 130px;
  font-size: 14px;
  color: #333333;
  height: 46px;
  line-height: 23px;
}
.section3 .input-box input {
  position: absolute;
  top: 10px;
  left: 150px;
  width: calc(100% - 165px);
  height: 34px;
  line-height: 34px;
  font-size: 15px;
  color: #000000;
  box-sizing: border-box;
  border: none;
}
.section3 .input-box textarea {
  position: absolute;
  top: 15px;
  left: 150px;
  width: calc(100% - 165px);
  height: 50px;
  line-height: 25px;
  font-size: 15px;
  color: #000000;
  box-sizing: border-box;
  border: none;
}
.section3 .image-box input {
  position: absolute;
  top: 15px;
  width: 100px;
  height: 120px;
  /*opacity: 0;*/
  /*background-color: yellow;*/
}
.section3 .image-box img {
  position: absolute;
  top: 15px;
  left: 150px;
  width: 100px;
  height: 120px;
}
.section3 .image-box .pre-btn {
  position: absolute;
  padding-top: -20px;
  top: 135px;
  left: 150px;
  width: 100px;
  height: 20px;
  text-align: center;
  font-size: 12px;
  /*color: #FFFFFF;*/
  background-color: #c41335;
}
.codebtn {
  position: absolute;
  top: 0px;
  right: 15px;
  width: 100px;
  height: 55px;
  color: #c41335;
  font-size: 14px;
  text-align: right;
  /*background-color: yellow;*/
}
.content4 .circle-image {
  position: absolute;
  top: 50px;
  left: calc(50% - 25px);
  width: 50px;
  height: 50px;
  background-image: url("../assets/icon-auth-circle.png");
  background-position: center;
  background-size: cover;
  animation: loading 3s linear infinite;
}
.content4 .tip {
  position: absolute;
  top: 120px;
  left: 0px;
  right: 0px;
  height: 20px;
  text-align: center;
  font-size: 12px;
  color: #000000;
}
.content4 .auth-btn {
  position: relative;
  top: 160px;
  left: calc(50% - 50px);
  width: 100px;
  height: 25px;
  line-height: 25px;
  text-align: center;
  font-size: 12px;
  color: #999999;
  border: solid 1px #999999;
  border-radius: 2px;
}
.section4 {
  position: fixed;
  width: 100%;
  bottom: 0px;
  height: 65px;
  line-height: 65px;
  background-color: #ffffff;
  border-top: solid #eeeeee 1px;
  box-sizing: border-box;
}
.section4 img {
  position: absolute;
  left: 15px;
  width: 22px;
  height: 22px;
  top: 21px;
  object-fit: cover;
}
.section4 .tip1 {
  position: absolute;
  top: 12px;
  left: 50px;
  height: 20px;
  line-height: 20px;
  color: #000000;
  font-size: 12px;
}
.section4 .tip2 {
  position: absolute;
  top: 32px;
  left: 43px;
  height: 20px;
  line-height: 20px;
  color: #c41335;
  font-size: 12px;
}
.section4 .submit {
  position: absolute;
  top: 10px;
  right: 15px;
  height: 45px;
  line-height: 45px;
  width: 150px;
  font-size: 16px;
  color: #ffffff;
  text-align: center;
  background-color: #c41335;
  border-radius: 4px;
}
</style>



// WEBPACK FOOTER //
// src/view/company-auth.vue